module.exports = __webpack_public_path__ + "img/DateRange.fb806dc9.svg";